export default {
  getIsNavOpen: (state) => state.isNavOpen,
  getNavOption: (state) => state.navOption,
  getIsMobileDensity: (state) => state.isMobileDensity,
  getUserSitemap: function(state) {
    return state.sitemap;
  },
};
